import { render, staticRenderFns } from "./PesquisaSolidao.vue?vue&type=template&id=6d1430fa&scoped=true"
import script from "./PesquisaSolidao.vue?vue&type=script&lang=js"
export * from "./PesquisaSolidao.vue?vue&type=script&lang=js"
import style0 from "./PesquisaSolidao.vue?vue&type=style&index=0&id=6d1430fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1430fa",
  null
  
)

export default component.exports